
  import { mapState } from 'vuex'
  import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
  import { Navigation, Pagination } from 'swiper'
  import 'swiper/swiper-bundle.css'
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  import commonUtils from '~/mixins/pages/mission-control/commonUtils'
  SwiperCore.use([Navigation, Pagination])
  export default {
    name: 'Theme2MissionDesktopVipPrivilegePage',
    components: {
      Swiper,
      SwiperSlide
    },
    mixins: [vipSettings, commonUtils],
    data() {
      return {
        displayTermAndConditionModal: false,
        displayClaimSuccessModal: false,
        claimLevelUpLoading: {},
        claimBirthdayLoading: {},
        isAlreadyScrolled: false, // To know if mounted has scrolled the tiers,
        loadingPage: true
      }
    },
    computed: {
      ...mapState({
        vipTiers: state => state.activities['vip-system'].vipTiers,
        vipSystem: state => state.activities['vip-system'].vipSystem,
        vipSystemLoading: state => state.activities['vip-system'].vipSystemLoading,
        vipTiersLoading: state => state.activities['vip-system'].vipTiersLoading,
        player: state => state.player.player,
        defaultCurrency: state => state.settings.defaultCurrency
      }),
      tiersList() {
        if (this.vipTiers?.tiers?.length)
          return this.vipTiers.tiers?.filter(el => el.tier_type === 1)
        return []
      },
      getTierProgress() {
        return (item, index) => {
          return this.getTierProgressFunc(item, index)
        }
      },
      isActiveCard() {
        return item => {
          if (!this.$cookie.get('token')) return ''
          const totalAmount = parseFloat(this.vipTiers?.player?.total_amount)
          const minRange = parseFloat(item.min_range)
          const maxRange = parseFloat(item.max_range)
          if (totalAmount >= minRange && totalAmount < maxRange) {
            return 'active'
          }
          return ''
        }
      }
    },
    watch: {
      vipTiers(value) {
        this.toSetDefaultUserTier()
      }
    },
    mounted() {
      this.$store.dispatch('activities/vip-system/getVipTiers', {
        currency: this.defaultCurrency
      })
      this.$store.dispatch('activities/vip-system/getVipSettings', {
        currency: this.defaultCurrency
      })

      // Get user current tier and make it as default
      this.toSetDefaultUserTier()
    },
    methods: {
      statusTextClass(status) {
        return status === 2 || status === 3 ? 'success--text' : 'grey--text'
      },
      statusColor(status) {
        return status === 2 || status === 3 ? 'success' : 'grey'
      },
      statusIcon(status) {
        return status === 2 || status === 3 ? 'mdi-check-circle' : 'mdi-close-circle'
      },
      async toSetDefaultUserTier() {
        if (this.isAlreadyScrolled) return
        // Delay 1000 ms
        await new Promise(resolve => setTimeout(resolve, 500))
        const playerCurrentTierId = this.vipTiers?.player?.current_tier?.id
        const tiers = this.vipTiers?.tiers
        if (playerCurrentTierId) {
          // Find the index of the current tier
          const currentTierIndex = tiers.findIndex(tier => tier.id === playerCurrentTierId)

          if (currentTierIndex > 4) {
            this.isAlreadyScrolled = true
            for (let i = 0; i < currentTierIndex - 1; i++) {
              this.onNext()
            }
          }
        }
      },
      onBack() {
        const elParent = document.getElementsByClassName('w-vip-privilege-slider')
        if (!elParent || !elParent[0]) return
        const elBack = elParent[0].getElementsByClassName('swiper-button-prev') //
        if (!elBack || !elBack[0]) return
        elBack[0].dispatchEvent(new MouseEvent('click'))
      },
      onNext() {
        const elParent = document.getElementsByClassName('w-vip-privilege-slider')
        if (!elParent || !elParent[0]) return
        const elNext = elParent[0].getElementsByClassName('swiper-button-next')
        if (!elNext || !elNext[0]) return
        elNext[0].dispatchEvent(new MouseEvent('click'))
      },
      async onClaim(tierId, type = 'level_up') {
        let claimStoreActionPath = 'activities/vip-system/claimLevelUpReward'
        if (type !== 'level_up') {
          this.claimBirthdayLoading = {
            ...this.claimBirthdayLoading,
            [tierId]: true
          }
          claimStoreActionPath = 'activities/vip-system/claimBirthdayReward'
        } else {
          this.claimLevelUpLoading = {
            ...this.claimLevelUpLoading,
            [tierId]: true
          }
        }
        const response = await this.$store.dispatch(claimStoreActionPath, tierId)
        if (response) {
          this.loadingPage = false
          await this.$store.dispatch('activities/vip-system/getVipTiers')
          this.loadingPage = true
          this.onDisplayClaimSuccessModal()
        }
        if (type !== 'level_up') {
          this.claimBirthdayLoading[tierId] = false
        } else {
          this.claimLevelUpLoading[tierId] = false
        }
      },
      onDisplayClaimSuccessModal() {
        this.displayClaimSuccessModal = true
        setTimeout(() => {
          this.displayClaimSuccessModal = false
        }, 3000)
      },

      getRankProgress(currentAmount, ranks) {
        const amount = Number(currentAmount)

        // Find current rank index
        let currentRankIndex = -1
        for (let i = 0; i < ranks.length; i++) {
          const min = Number(ranks[i].min_range)
          const max = Number(ranks[i].max_range)
          if (amount >= min && amount < max) {
            currentRankIndex = i
            break
          }
        }

        if (currentRankIndex === -1) {
          return null // Not in any rank
        }

        const currentRank = ranks[currentRankIndex]
        const prevRank = ranks[currentRankIndex - 1] || null
        const nextRank = ranks[currentRankIndex + 1] || null
        let progressToNext = null

        if (nextRank) {
          const currMin = Number(currentRank.min_range)
          const currMax = Number(currentRank.max_range)
          const currAmount = amount

          progressToNext = (100 * (currAmount - currMin)) / (currMax - currMin)

          progressToNext = Math.max(0, Math.min(progressToNext, 100))
        }

        return {
          previousRank: prevRank,
          currentRank,
          nextRank,
          progressToNext: progressToNext !== null ? progressToNext.toFixed(2) : ''
        }
      },
      getTierProgressFunc(item, index) {
        const totalAmount = parseFloat(this.vipTiers?.player?.total_amount)
        const minRange = parseFloat(item.min_range)
        const maxRange = parseFloat(item.max_range)
        const obj = {
          is_done: false,
          progress: 0
        }
        if (!this.$cookie.get('token')) return obj

        if (totalAmount >= minRange && totalAmount < maxRange) {
          obj.is_done = true
          obj.progress = ((totalAmount - minRange) / (maxRange - minRange)) * 100
        } else if (totalAmount >= maxRange) {
          obj.is_done = true
          obj.progress = 100
        }
        // Since the first progress line starts with position 50% of the progress
        // That's the reason why the progress is + 50
        if (index === 0) {
          obj.progress = obj.progress + 50
        } else if (index === this.tiersList.length - 1) {
          // Get the previous progress
          const previousProgress = this.getTierProgressFunc(this.tiersList[index - 1], index - 1)
          if (previousProgress.progress >= 150) {
            obj.progress = 100
            obj.is_done = true
          }
        } else {
          // Get the previous progress
          const previousProgress = this.getTierProgressFunc(this.tiersList[index - 1], index - 1)
          if (previousProgress.progress > 100) {
            let currentProgressAndPreviousProgress = obj.progress + previousProgress.progress - 100
            if (
              currentProgressAndPreviousProgress > 40 &&
              currentProgressAndPreviousProgress < 56
            ) {
              currentProgressAndPreviousProgress = 56
            }
            obj.progress = currentProgressAndPreviousProgress
          }
        }
        if (obj.progress <= 100 && obj.progress >= 99) {
          obj.progress = 99
        }

        if (this.tiersList.length === 1) {
          obj.progress = 100
        }

        return obj
      },
      getProgressLineWidth(index) {
        return index === this.tiersList.length - 1 ? '50%' : '104%'
      }
    }
  }
